import { render, staticRenderFns } from "./TextBoxBehaviorEditor.vue?vue&type=template&id=0ad1152d&scoped=true&"
import script from "./TextBoxBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TextBoxBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1152d",
  null
  
)

export default component.exports